module.exports = __webpack_public_path__ + "img/login-bg-v1-july.b80360cc.jpg";